import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(() => {});
};

Vue.use(Router);

const constantRoutes = [
    {
        path: "/loading",
        name: "loading",
        component: () => import("@/views/loading.vue"),
    },
    {
        path: "/",
        name: "home",
        component: () => import("@/views/home/index.vue"),
    },
    {
        path: "/collection",
        name: "collection",
        component: () => import("@/views/collection/index.vue"),
    },
    {
        path: "/bill",
        name: "bill",
        component: () => import("@/views/bill/index.vue"),
    },
    {
        path: "/payment",
        name: "payment",
        component: () => import("@/views/payment/index.vue"),
    },
    {
        path: "/issueCard",
        name: "issueCard",
        component: () => import("@/views/issueCard/index.vue"),
    },
     {
        path: "/aboutUs",
        name: "aboutUs",
        component: () => import("@/views/aboutUs/index.vue"),
    },
    {
        path: "/solution",
        name: "solution",
        component: () => import("@/views/solution/index.vue"),
    },
];

const createRouter = () =>
    new Router({
        mode: "hash",
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes,
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
